const MenuItems = [
	{
		title: 'Home',
		scrollTo: 'home',
		url: '#',
		cName: 'nav-links'
	},
	{
		title: 'Features',
		scrollTo: 'features__section',
		url: '#',
		cName: 'nav-links'
	},
	{
		title: 'Services',
		scrollTo: 'services',
		url: '#',
		cName: 'nav-links'
	},
	{
		title: 'About',
		scrollTo: 'about',
		url: '#',
		cName: 'nav-links'
	},
	{
		title: 'Contact Us',
		scrollTo: 'contact',
		url: '#',
		cName: 'nav-links'
	}
];

export default MenuItems;
